"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JOAlert = void 0;
const lit_html_1 = require("lit-html");
const reduxular_1 = require("reduxular");
const define_custom_element_1 = require("../../utilities/define-custom-element");
const test_id_directive_1 = require("../directives/test-id.directive");
require("./jo-button.element");
const InitialState = {
    alertTitle: 'NOT_SET',
    alertMessage: 'NOT_SET',
};
class JOAlert extends HTMLElement {
    constructor(alertTitle, alertMessage) {
        super();
        this.store = (0, reduxular_1.createObjectStore)(InitialState, (state) => (0, lit_html_1.render)(this.render(state), this), this);
        this.store.alertTitle = alertTitle;
        this.store.alertMessage = alertMessage;
    }
    buttonClicked(response) {
        if (response === true) {
            this.dispatchEvent(new CustomEvent('ok'));
        }
        else {
            this.dispatchEvent(new CustomEvent('cancel'));
        }
    }
    render(state) {
        return (0, lit_html_1.html) `
            <style>
                .jo-alert--main-container {
                    font-family: sans-serif;
                }

                .jo-alert--darken-screen {
                    position: fixed;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    background: rgba(0, 0, 0, 0.65);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    z-index: var(--z-index-3);
                }

                @media (max-width: 768px) {
                    .jo-alert--darken-screen {
                        align-items: flex-start;
                    }
                }

                .jo-alert--fade-in {
                    opacity: 0;
                    animation-name: jo-alert--fade-in;
                    animation-duration: 0.125s;
                    animation-fill-mode: forwards;
                }

                .jo-alert--window {
                    width: 35%;
                    background: white;
                    border-radius: 5px;
                    box-shadow: 0 0 20px rgba(0, 0, 0, 0.3);
                }

                @media (max-width: 1280px) {
                    .jo-alert--window {
                        width: 50%;
                    }
                }

                @media (max-width: 768px) {
                    .jo-alert--window {
                        margin-top: 40%;
                        width: 75%;
                    }
                }

                .jo-alert--window-popup {
                    opacity: 0;
                    transform: scale(0.5);
                    animation-name: jo-alert--window-popup;
                    animation-duration: 0.15s;
                    animation-fill-mode: forwards;
                }

                .jo-alert--title-bar {
                    background: var(--jo-accent-background-light);
                    font-weight: bold;
                    padding: 1.2em;
                    border-bottom: 1px solid var(--jo-accent-background-light);
                    box-sizing: border-box;
                    display: flex;
                    align-content: center;
                    justify-content: space-between;
                }

                .jo-alert--alertTitle {
                    font-weight: bold;
                }

                .jo-alert--close {
                    color: var(--jo-text-default);
                    transform: scale(1.5);
                    cursor: pointer;
                }

                .jo-alert--close:hover {
                    color: black;
                    transform: scale(1.65);
                }

                .jo-alert--alertMessage {
                    padding: 1.5em;
                    background: #fff;
                    border-bottom: 1px solid var(--jo-accent-background-light);
                    box-sizing: border-box;
                    white-space: pre-wrap;
                }

                .jo-alert--buttons-row {
                    background: var(--jo-accent-background-light);
                    padding: 1em;
                    display: flex;
                    justify-content: flex-end;
                }

                @keyframes jo-alert--fade-in {
                    to {
                        opacity: 1;
                    }
                }

                @keyframes jo-alert--window-popup {
                    to {
                        opacity: 1;
                        transform: scale(1);
                    }
                }
            </style>

            <div class="jo-alert--main-container">
                <div class="jo-alert--darken-screen jo-alert--fade-in">
                    <div class="jo-alert--window jo-alert--window-popup">
                        <div class="jo-alert--title-bar" ${(0, test_id_directive_1.testId)('jo-alert-title')}>
                            <div>${state.alertTitle}</div>
                        </div>

                        <div class="jo-alert--alertMessage" ${(0, test_id_directive_1.testId)('jo-alert-message')}>
                            <div>${state.alertMessage}</div>
                        </div>

                        <div class="jo-alert--buttons-row">
                            <jo-button
                                ${(0, test_id_directive_1.testId)('jo-alert-okay-button')}
                                id="jo-alert-button"
                                .type=${'ALERT_BUTTON_ACCEPT'}
                                .text=${'OK'}
                                @joButtonClick=${() => this.buttonClicked(true)}
                            ></jo-button>
                        </div>
                    </div>
                </div>
            </div>
        `;
    }
}
exports.JOAlert = JOAlert;
(0, define_custom_element_1.defineCustomElement)('jo-alert', JOAlert);
